import _ from 'underscore';

export class DecoratedODataAdapter {
  constructor({
    adapter,
    getTTL,
  }) {
    this.adapter = adapter;
    this.getTTL = getTTL;
  }

  findAll(definition, query, options) {
    const ttl = this.getTTL(definition, query, options);
    const { entitySet, headers, successCallback } = options;
    const path = _.result(entitySet, 'path', null);
    const params = _.chain(entitySet)
      .result('navigation')
      .result('parameters', null)
      .value();
    const key = [_.omit(query, 'cacheBusterFlag'), path, params];
    let cacheHit = true;

    const cachedResult = options.cacheResult(key, () => {
      cacheHit = false;
      return this.adapter.findAll(definition, query, _.defaults({
        headers: _.defaults({
          'x-ms-lastwritetime': options.getCacheHint() || 'Max',
        }, headers),
        successCallback: (...args) => {
          const [res] = args;
          const cacheCreationTime = _.result(res, '@ns.objectcachecreationtime', null);

          if (cacheCreationTime) {
            options.setCacheHint(cacheCreationTime, ttl);
          }
          if (_.isFunction(successCallback)) {
            successCallback(...args);
          }
        },
      }, options)).then((result) => {
        if (result.errors) {
          options.delResult(key);
        }
        return result;
      });
    }, ttl);

    if (_.isFunction(options.cacheStateCallback)) {
      options.cacheStateCallback(cacheHit);
    }

    return cachedResult;
  }
}
